import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class EmailVerifiedGuard {
  constructor(private router: Router, private authService: AuthService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    return this.authService.userHasEmailVerified().then((isVerified) => {
      if (!isVerified) {
        console.log("taking back to verificate...");
        this.router.navigate(["/authentication/verificate"]);
        return false;
      } else {
        return true;
      }
    });
  }
}
